"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WixContext = void 0;
const react_1 = require("react");
exports.WixContext = (0, react_1.createContext)(undefined);
